import { PopupMenu as _PopupMenu } from './PopupMenu.component';
import { PopupMenuItem, PopupMenuTrigger } from './PopupMenuItem';

export { PopupMenuContext } from './Context';

/**
 * @deprecated use `Menu` instead
 */
export const PopupMenu = Object.assign(_PopupMenu, {
  Item: PopupMenuItem,
  TriggerItem: PopupMenuTrigger,
});
